export default __webpack_public_path__ + "static/media/supply-sub-tier.de9fcf65.svg";